import React from 'react';
import { Outlet } from 'react-router-dom';
import '../components/css/course.css'; // Import the course.css file

function CourseLayout() {
  return (
    <div className="course-layout">
      <div className="course-content">
        <Outlet /> {/* This is where the child route (CourseView) will be rendered */}
      </div>
    </div>
  );
}

export default CourseLayout;